<ng-container *transloco="let t;">
    <div class="container d-flex justify-content-center align-items-center">
        <div class="w-100 py-4" style="max-width: 80rem;">
            <breadcrumb [items]='[{ label: t("header.frontpage"), route: "/"} ]'></breadcrumb>
            <div *ngIf="!(isLoading$ | async); else isLoadingState" class="content-box scroll-to">
                <h3 class="card-title">{{ t('doctorschemas.title') }}</h3>
                <div class="row g-3 mb-3">
                    <div class="col-md-6 me-auto">
                        <p class="text-muted">{{ t('doctorschemas.searchbarundertitle') }}
                            <br>
                            <span class="fw-bold">
                                {{ t('doctorschemas.searchterms') }}
                            </span>
                        </p>
                        <div class="search-form">
                            <svg class="icon icon-md icon-primary" aria-hidden="true" focusable="false">
                                <use xlink:href="assets/icons.svg#icon-search"></use>
                            </svg>
                            <input type="text" [value]="searchQuery$ | async" id="schemaSearchbar"
                                class="form-control form-input search-input"
                                [placeholder]="t('doctorschemas.searchplaceholder')" (input)="onSearch()">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card card-body mb-3 schema-terms-info">
                            <div class="fw-medium">{{ t('doctorschemas.schematermsinfo') }}</div>
                        </div>
                        <button *ngIf="!isProduction"
                            class="btn wp-btn d-flex justify-content-center align-items-center float-end" role="button"
                            data-bs-toggle="modal" data-bs-target="#newSchemaModal">
                            <svg class="icon-dark-bg icon-sm me-2" aria-hidden="true" focusable="false">
                                <use xlink:href="assets/icons.svg#icon-plus"></use>
                            </svg>
                            <span>{{ t('doctorschemas.newschema') }}</span>
                        </button>
                    </div>
                </div>

                <div class="modal modal-lg fade" id="newSchemaModal" data-bs-backdrop="static" data-bs-keyboard="false"
                    tabindex="-1" aria-labelledby="newSchemaModalLabel">
                    <new-schema-dialog (newRequisitionEvent)="updateSchemaStore()"></new-schema-dialog>
                </div>

                <ng-container *media="'(min-width: 992px)'">
                    <div class="table-responsive">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="header-flex sortable" (click)="sortBy('patientName')"
                                            (keyup.enter)="sortBy('patientName')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.patient') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'patientName'" class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="header-flex sortable" (click)="sortBy('schemaTypeName')"
                                            (keyup.enter)="sortBy('schemaTypeName')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.schema') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'schemaTypeName'" class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="header-flex sortable" (click)="sortBy('createdDate')"
                                            (keyup.enter)="sortBy('createdDate')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.createdat') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'createdDate'" class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="header-flex sortable" (click)="sortBy('doctorOrganization')"
                                            (keyup.enter)="sortBy('doctorOrganization')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.createdby') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'doctorOrganization'"
                                                class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="header-flex sortable" (click)="sortBy('doctorInitials')"
                                            (keyup.enter)="sortBy('doctorInitials')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.initials') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'doctorInitials'" class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th style="white-space: nowrap;">
                                        <div class="header-flex sortable" (click)="sortBy('changedDate')"
                                            (keyup.enter)="sortBy('changedDate')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.updatedat') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'changedDate'" class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="header-flex sortable" (click)="sortBy('validTo')"
                                            (keyup.enter)="sortBy('validTo')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.validperiod') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'validTo'" class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                    <th>
                                        <div class="header-flex sortable" (click)="sortBy('schemaStatus')"
                                            (keyup.enter)="sortBy('schemaStatus')" tabindex="0">
                                            <span class="header-text">
                                                {{ t('schema.tableheader.status') }}
                                            </span>
                                            <span *ngIf="sortColumn$.value == 'schemaStatus'" class="header-arrow">
                                                {{ sortDirection$.value === 'asc' ? '↓' : '↑' }}
                                            </span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="table-group-divider">
                                <tr *ngFor="let schema of paginatedSchemas$ | async"
                                    [ngClass]="{'tr-schema-disabled': schema.schemaStatus == SchemaStatus.EXPIRED }"
                                    (click)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                                    (keyup.enter)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                                    tabindex="0">
                                    <td [attr.data-content]="t('schema.tableheader.patient')">{{ schema.patientName
                                        + "
                                        " +
                                        schema.patientSurname
                                        + " (" +
                                        schema.patientCpr + ")" }}</td>
                                    <td [attr.data-content]="t('schema.tableheader.schema')">{{
                                        schema.schemaTypeName }}
                                    </td>
                                    <td [attr.data-content]="t('schema.tableheader.createdat')">{{
                                        schema.createdDate |
                                        dateFormatted }}</td>
                                    <td [attr.data-content]="t('schema.tableheader.createdby')">{{
                                        schema.doctorOrganization
                                        }}
                                    </td>
                                    <td [attr.data-content]="t('schema.tableheader.initials')">{{
                                        schema.doctorInitials
                                        }}
                                    </td>
                                    <td [attr.data-content]="t('schema.tableheader.updatedat')">{{
                                        schema.changedDate | datetimeFormatted }}</td>
                                    <td [attr.data-content]="t('schema.tableheader.validperiod')">{{
                                        schema.validFrom |
                                        dateFormatted }} - {{ schema.validTo |
                                        dateFormatted }}</td>
                                    <td [attr.data-content]="t('schema.tableheader.status')">
                                        {{ schema.schemaStatus | schemaStatus | async }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="pages > 1" class="row">
                        <div class="col-auto align-content-center" style="min-width: 20%;">
                            <button type="button" class="btn btn-sm wp-btn-outline float-start"
                                [ngClass]="{'d-none' : currentPage === 1}"
                                [attr.aria-label]="t('schemapagination.previous')" (click)="changePage(currentPage - 1)"
                                (keyup.enter)="changePage(currentPage - 1)" tabindex="0">
                                <svg class="icon-sm icon-primary" aria-hidden="true" focusable="false">
                                    <use xlink:href="assets/icons.svg#icon-chevron-left"></use>
                                </svg>
                                <span>{{ t('schemapagination.previous') }}</span>
                            </button>
                        </div>
                        <div class="col">
                            <nav *ngIf="!(isLoading$ | async)" aria-label="Schema table pagination">
                                <ul class="pagination pagination-sm justify-content-center m-0">
                                    <li *ngIf="!visiblePaginationPages.includes(1)" class="page-item">
                                        <a class="page-link" [attr.aria-label]="t('schemapagination.firstpage')"
                                            [ngClass]="{'d-none': currentPage < paginationInterval}"
                                            (click)="changePage(1)" (keyup.enter)="changePage(1)" tabindex="0">
                                            <span aria-hidden="true">1</span>
                                        </a>
                                    </li>
                                    <li *ngIf="!visiblePaginationPages.includes(1)" class="page-item"
                                        style="cursor: default;">
                                        <div class="page-link">...</div>
                                    </li>
                                    <li class="page-item" *ngFor="let page of visiblePaginationPages"
                                        [class.active]="page === currentPage">
                                        <a class="page-link" (click)="changePage(page)" (keyup.enter)="changePage(page)"
                                            [attr.aria-label]="t('accessibility.gotopage')+' '+page" tabindex="0">{{
                                            page }}</a>
                                    </li>
                                    <li *ngIf="!visiblePaginationPages.includes(lastPage)" class="page-item">
                                        <div class="page-link">...</div>
                                    </li>
                                    <li *ngIf="!visiblePaginationPages.includes(lastPage)" class="page-item">
                                        <a class="page-link" [attr.aria-label]="t('schemapagination.lastpage')"
                                            (click)="changePage(lastPage)" (keyup.enter)="changePage(lastPage)"
                                            tabindex="0">
                                            <span aria-hidden="true">{{ lastPage }}</span>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="col-auto align-content-center" style="min-width: 20%;">
                            <button type="button" class="btn btn-sm wp-btn-outline float-end"
                                [attr.aria-label]="t('schemapagination.next')" (click)="changePage(currentPage + 1)"
                                [ngClass]="{'d-none' : currentPage === lastPage}">
                                <span>{{ t('schemapagination.next') }}</span>
                                <svg class="icon-sm icon-primary" aria-hidden="true" focusable="false">
                                    <use xlink:href="assets/icons.svg#icon-chevron-right"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </ng-container>

                <ng-container *media="'(max-width: 991px)'">
                    <div class="row g-3 mb-3 schema-card-list">
                        <div class="col-12" *ngFor="let schema of paginatedSchemas$ | async"
                            [ngClass]="{'tr-schema-disabled': schema.schemaStatus == SchemaStatus.EXPIRED }">
                            <div class="card"
                                (click)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                                (keyup.enter)="onSchemaClicked(schema.schemaId, schema.sentCount, schema.schemaStatus)"
                                tabindex="0">
                                <div class="card-body">
                                    <div class="row align-items-center">
                                        <div class="col me-auto">
                                            <h5 class="card-title">{{ schema.schemaTypeName }}</h5>
                                        </div>
                                        <div class="col-auto">
                                            <span class="d-flex gap-1 align-items-center">
                                                <div style="font-size: small;">
                                                    {{ schema.schemaStatus | schemaStatus | async }}
                                                </div>
                                                <svg class="icon icon-md icon-primary" aria-hidden="true"
                                                    focusable="false">
                                                    <use xlink:href="assets/icons.svg#icon-file-text"></use>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row g-3">
                                        <div class="col me-auto">
                                            <div style="font-size: small;">{{ schema.patientName
                                                + "
                                                " +
                                                schema.patientSurname
                                                + " (" +
                                                schema.patientCpr + ")" }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-3">
                                        <div class="col me-auto">
                                            <div style="font-size: small;">{{ t('schema.tableheader.createdby') }}
                                            </div>
                                            <div class="fw-light" style="font-size: small;">{{
                                                schema.doctorOrganization }}</div>
                                        </div>
                                        <div class="col-auto text-end">
                                            <div style="font-size: small;">{{ t('schema.tableheader.createdat') }}
                                            </div>
                                            <div class="fw-light" style="font-size: small;">{{ schema.createdDate |
                                                dateFormatted }}</div>
                                        </div>
                                    </div>
                                    <div class="row g-3">
                                        <div class="col me-auto">
                                            <div style="font-size: small;">{{ t('schema.tableheader.validperiod') }}
                                            </div>
                                            <div class="fw-light" style="font-size: small;">{{
                                                schema.validFrom |
                                                dateFormatted }} - {{ schema.validTo |
                                                dateFormatted }}</div>
                                        </div>
                                        <div class="col-auto text-end">
                                            <div style="font-size: small;">{{ t('schema.tableheader.updatedat') }}
                                            </div>
                                            <div class="fw-light" style="font-size: small;">{{
                                                schema.changedDate | datetimeFormatted }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center">
                        <div class="col-4 text-start">
                            <button type="button" class="btn btn-sm wp-btn-outline"
                                [attr.aria-label]="t('schemapagination.previous')" (click)="changePage(currentPage - 1)"
                                [ngClass]="{'d-none': currentPage === 1, 'disabled': currentPage === 1}">
                                <svg class="icon-primary icon-sm" aria-hidden="true" focusable="false">
                                    <use xlink:href="assets/icons.svg#icon-chevron-left"></use>
                                </svg>
                            </button>
                        </div>
                        <div class="col-4 text-center">
                            {{ currentPage }} <span>{{ t('doctorschemas.of') }} </span>{{ lastPage}}
                        </div>
                        <div class="col-4 text-end">
                            <button type="button" class="btn btn-sm wp-btn-outline"
                                [attr.aria-label]="t('schemapagination.next')" (click)="changePage(currentPage + 1)"
                                [ngClass]="{'d-none': currentPage === lastPage, 'disabled': currentPage === lastPage}">
                                <svg class="icon-primary icon-sm" aria-hidden="true" focusable="false">
                                    <use xlink:href="assets/icons.svg#icon-chevron-right"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
</ng-container>

<ng-template #isLoadingState>
    <overlay-loading-spinner-border [show]="showLoadingSignal" />
</ng-template>